var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-multiselect-container"},[_c('vue-simple-multi-select',{attrs:{"options":_vm.options,"placeholder":_vm.placeholder,"option-label":_vm.optionLabel,"max":_vm.maxItems,"classes":_vm.classes,"max-results":_vm.maxItems},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }